import type { AnyAction, Dispatch, ThunkAction } from '@reduxjs/toolkit';
import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import type { ThunkDispatch } from 'redux-thunk';
import type { Action } from 'redux';
import session from '../../account/sessionSlice';
import editor from '../../editor/editorSlice';
import onboarding from '../../onboarding/onboardingSlice';
import ui from '../../ui/uiSlice';
import Logger from '../../utils/Logger';

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action
>;

export const reducer = {
  editor,
  onboarding,
  ui,
  session,
};

const store = configureStore({
  reducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware(getDefaultMiddleware) {
    const middlewares = [
      Logger.reduxMiddleware,
      ...getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: false,
      }),
    ];

    if (process.env.NODE_ENV !== 'production') {
      middlewares.push(
        createLogger({
          level: 'info',
          collapsed: true,
        }),
      );
    }

    return middlewares;
  },
});

export type RootState = ReturnType<typeof store.getState>;
type Store = Omit<typeof store, 'dispatch'> & {
  dispatch: ThunkDispatch<RootState, undefined, AnyAction> &
    Dispatch<AnyAction>;
};

const getReduxStore = (): Store => store;
export default getReduxStore;
